import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-check",
  "use": "icon-th-check-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-check\">\n<path d=\"M28.7076 9.70745L12.7076 25.7074C12.6147 25.8004 12.5044 25.8742 12.383 25.9245C12.2616 25.9748 12.1315 26.0007 12.0001 26.0007C11.8687 26.0007 11.7385 25.9748 11.6171 25.9245C11.4957 25.8742 11.3854 25.8004 11.2926 25.7074L4.29257 18.7074C4.10493 18.5198 3.99951 18.2653 3.99951 17.9999C3.99951 17.7346 4.10493 17.4801 4.29257 17.2924C4.48021 17.1048 4.7347 16.9994 5.00007 16.9994C5.26543 16.9994 5.51993 17.1048 5.70757 17.2924L12.0001 23.5862L27.2926 8.29245C27.4802 8.1048 27.7347 7.99939 28.0001 7.99939C28.2654 7.99939 28.5199 8.1048 28.7076 8.29245C28.8952 8.48009 29.0006 8.73458 29.0006 8.99995C29.0006 9.26531 28.8952 9.51981 28.7076 9.70745Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-check.svg
// module id = JHsp
// module chunks = 84